module.exports = __webpack_public_path__ + "img/9788998602246.3a955e39.jpg";